import React from "react";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { colors } from "../../theme";
import "./login.css";

class LoginView extends React.Component {
  state = {
    detail: {},
    tokenSent: false,
  };

  handleChange = (value, prop) => {
    var t = this.state.detail;
    t[prop] = value;
    this.setState({
      detail: t,
    });
  };

  submit = () => {
    const { username, password } = this.state.detail;

    if (this.state.detail.isReset) {
      this.props.dispatchAuthenticate(username, password, null, null, true);
      this.setState({
        tokenSent: true,
      });
    } else {
      this.props.dispatchAuthenticate(username, password);
    }
  };

  reset = () => {
    const { username, password, confirmPassword, token } = this.state.detail;
    this.props.dispatchAuthenticate(
      username,
      password,
      token,
      confirmPassword,
      true
    );
  };

  forgotToken = () => {
    this.setState({
      detail: {
        ...this.state.detail,
        isReset: true,
      },
    });
  };

  render() {
    if (this.props.user && this.props.user._id) {
      return <Redirect to="/" />;
    }

    return (
      <div className="login-container">
        {!this.state.detail.isReset && (
          <div className="login-card">
            <Link to="/">
              <img
                src="/moneyapp_blue.png"
                alt="MoneyApp Logo"
                className="login-logo"
              />
            </Link>
            <h1 className="login-title">sign in</h1>
            <hr className="login-divider" />

            {this.props.peopleState.signInErrorMessage && (
              <div className="alert alert-danger">
                {this.props.peopleState.signInErrorMessage}
              </div>
            )}

            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  data-testid="login-username"
                  value={this.state.detail.username || ""}
                  onChange={(e) =>
                    this.handleChange(e.target.value, "username")
                  }
                />
                <i className="fas fa-user form-icon"></i>
              </div>

              <div className="form-group">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  data-testid="login-password"
                  value={this.state.detail.password || ""}
                  onChange={(e) =>
                    this.handleChange(e.target.value, "password")
                  }
                />
                <i className="fas fa-lock form-icon"></i>
              </div>

              <a
                href="#"
                className="forgot-password"
                onClick={this.forgotToken}
              >
                Forgot password?
              </a>

              <button
                type="submit"
                className="login-button"
                data-testid="login-submit"
                onClick={this.submit}
              >
                Sign In
              </button>
            </form>

            <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
              <Link to="/register" style={{ color: "#666", fontSize: "0.9rem" }}>
                Don't have an account? <span style={{ color: "#007bff", fontWeight: 600 }}>Sign Up</span>
              </Link>
            </div>
          </div>
        )}

        {this.state.detail.isReset && !this.state.tokenSent && (
          <div className="login-card">
            <Link to="/">
              <img
                src="/moneyapp_blue.png"
                alt="MoneyApp Logo"
                className="login-logo"
              />
            </Link>
            <h1 className="login-title">reset password</h1>
            <hr className="login-divider" />

            {this.props.peopleState.signInErrorMessage && (
              <div className="alert alert-danger">
                {this.props.peopleState.signInErrorMessage}
              </div>
            )}

            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  value={this.state.detail.username || ""}
                  onChange={(e) =>
                    this.handleChange(e.target.value, "username")
                  }
                />
                <i className="fas fa-user form-icon"></i>
              </div>

              <button
                type="submit"
                className="login-button"
                onClick={this.submit}
              >
                Send Reset Token
              </button>
            </form>
          </div>
        )}

        {this.state.tokenSent && (
          <div className="login-card">
            <Link to="/">
              <img
                src="/moneyapp_blue.png"
                alt="MoneyApp Logo"
                className="login-logo"
              />
            </Link>
            <h1 className="login-title">Reset Password</h1>
            <hr className="login-divider" />

            {this.props.peopleState.signInErrorMessage && (
              <div className="alert alert-danger">
                {this.props.peopleState.signInErrorMessage}
              </div>
            )}

            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  value={this.state.detail.username || ""}
                  onChange={(e) =>
                    this.handleChange(e.target.value, "username")
                  }
                />
                <i className="fas fa-user form-icon"></i>
              </div>

              <div className="form-group">
                <input
                  type="password"
                  className="form-control"
                  placeholder="New Password"
                  value={this.state.detail.password || ""}
                  onChange={(e) =>
                    this.handleChange(e.target.value, "password")
                  }
                />
                <i className="fas fa-lock form-icon"></i>
              </div>

              <div className="form-group">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Confirm Password"
                  value={this.state.detail.confirmPassword || ""}
                  onChange={(e) =>
                    this.handleChange(e.target.value, "confirmPassword")
                  }
                />
                <i className="fas fa-lock form-icon"></i>
              </div>

              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Reset Token"
                  value={this.state.detail.token || ""}
                  onChange={(e) => this.handleChange(e.target.value, "token")}
                />
                <i className="fas fa-key form-icon"></i>
              </div>

              <button
                type="submit"
                className="login-button"
                onClick={this.reset}
              >
                Reset Password
              </button>
            </form>
          </div>
        )}
      </div>
    );
  }
}

export default LoginView;
